/** Largest single donation amount accepted in the UI, in whole currency units. */
export const MAX_MAJOR_UNITS = 1_000_000;

/** 500 -> "5.00" (whole amounts keep two decimals so "5" never reads as 5 cents). */
export function centsToAmountText(cents: number | null | undefined): string {
  if (typeof cents !== 'number' || !Number.isFinite(cents) || cents <= 0) return '';
  const whole = Math.floor(cents / 100);
  const fraction = String(Math.round(cents % 100)).padStart(2, '0');
  return `${whole}.${fraction}`;
}

/**
 * "5", "5.5", "5.50" or "5,50" -> cents. Returns null for anything that is not a plain amount
 * with at most two decimals, so callers can show a message instead of guessing.
 * Works on the digits themselves (no floating point), so 19.99 is exactly 1999.
 */
export function amountTextToCents(text: string): number | null {
  const cleaned = text.trim().replace(/\s/g, '');
  if (!cleaned) return null;
  if (!/^\d+([.,]\d{0,2})?$/.test(cleaned) && !/^[.,]\d{1,2}$/.test(cleaned)) return null;

  const [wholePart, fractionPart = ''] = cleaned.replace(',', '.').split('.');
  const cents = Number(wholePart || '0') * 100 + Number(fractionPart.padEnd(2, '0'));
  return cents > MAX_MAJOR_UNITS * 100 ? null : cents;
}
